/* eslint-disable react-hooks/exhaustive-deps */
import { format } from "date-fns";
import { useSignalR } from "context/SignalRContext";
import { useCallback, useState } from "react";
import {
  OrderProps,
  OrderUpdateActions,
} from "store/modules/Orders/types.store";

export const useOrders = () => {
  const { ordersSignal } = useSignalR();
  const [currentTab, setCurrentTab] = useState("1");
  const initialView = localStorage.getItem("@ctech:ordersView");
  const [ordersSelected, setOrdersSelected] = useState<number | null>(null);
  const [openModal, setOpenModal] = useState(true);
  const [openModalFinallyOrder, setOpenModalFinallyOrder] = useState(true);
  const [
    openModalFinallyOrderDescription,
    setOpenModalFinallyOrderDescription,
  ] = useState(false);
  const [openModalCode, setOpenModalCode] = useState(
    false || !localStorage.getItem("@ctech:firstAccessiWthoutRequest"),
  );
  const [view, setView] = useState(initialView);
  const [modalProps, setModalProps] = useState<{
    orderId: string;
    consumerId: string;
    type: OrderUpdateActions;
    paymentType: string;
    valeGas: boolean;
  } | null>(null);
  const [typeDetailsKanban, setTypeDetailsKanban] = useState({
    currentTab: 0,
    type: "",
  });

  const typeOrders = (type: string) => {
    const ordersSignalFilter =
      ordersSignal
        ?.filter((x: any) => x.dealerState === type)
        .filter((data: OrderProps) => {
          if (
            data.payment.type !== "INAPP" ||
            data.dealerState === "Finalized" ||
            (data.payment.type === "INAPP" && data.paymentStatus === "Payed")
          ) {
            return data;
          }
          return "";
        }) || [];

    if (type === "Finalized") {
      const ordersSignalFinalized = ordersSignalFilter.filter(
        (order: any) =>
          Number(format(new Date(order.createdAt), "dd")) ===
          Number(format(new Date(), "dd")),
      );

      return ordersSignalFinalized;
    }

    return ordersSignalFilter;
  };

  const handleChangeTab = async (_: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
    setOrdersSelected(null);
  };

  const handleOrderUpdate = useCallback(
    (
      type: OrderUpdateActions,
      orderId: string,
      consumerId: string,
      paymentType: string,
      valeGas: boolean,
    ) => {
      setModalProps({ orderId, type, consumerId, paymentType, valeGas });
    },
    [],
  );

  return {
    handleChangeTab,
    handleOrderUpdate,
    typeOrders,
    ordersSignal,
    currentTab,
    setCurrentTab,
    typeDetailsKanban,
    setTypeDetailsKanban,
    modalProps,
    setModalProps,
    ordersSelected,
    setOrdersSelected,
    view,
    setView,
    openModal,
    setOpenModal,
    openModalCode,
    setOpenModalCode,
    openModalFinallyOrder,
    setOpenModalFinallyOrder,
    openModalFinallyOrderDescription,
    setOpenModalFinallyOrderDescription,
  };
};
